import { SidebarPortal } from "@/features/Navigation/components/SidebarPortal";
import { MemoNavigator } from "../InvestmentMemo/components/MemoNavigator";
import { atom, useAtom } from "jotai";
import { showCompanyListAtom } from "@/features/Navigation/state";
import InvestmentMemo from "../InvestmentMemo/InvestmentMemo";
import { getSFDCDataV2 } from "@/entities/Deal/Deal.queries";
import { useApiQuery } from "@/api/hooks/useApiQuery";
import clsx from "clsx";
import { useRouter } from "@/utils/router";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";

const showOpportunitiesListAtom = atom(true);

export function OpportunityPage() {
    const [showCompanyList] = useAtom(showCompanyListAtom);
    const [showOpportunitiesList, setShowOpportunitiesList] = useAtom(
        showOpportunitiesListAtom,
    );
    const sfdcDataV2 = useApiQuery(getSFDCDataV2);
    const router = useRouter();

    return (
        <div>
            {!showCompanyList && showOpportunitiesList && (
                <SidebarPortal>
                    {sfdcDataV2.data?.sfdcOpportunities?.map((opportunity) => (
                        <div
                            key={opportunity.sfdcOpportunityId}
                            className={clsx(
                                "w-full cursor-pointer select-none rounded-md p-4",
                                "body-s text-left",
                                router.params.opportunityId ===
                                    opportunity.sfdcOpportunityId
                                    ? "text-default bg-slate-700"
                                    : "subdued hover:bg-slate-700 hover:text-slate-200",

                                "transition-colors duration-150 ease-in-out",
                            )}
                            onClick={() => {
                                router.navigate(
                                    `/beta/companies/${router.params.companyId}/opportunities/${opportunity.sfdcOpportunityId}`,
                                );
                                setShowOpportunitiesList(false);
                            }}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    router.navigate(
                                        `/beta/companies/${router.params.companyId}/opportunities/${opportunity.sfdcOpportunityId}`,
                                    );
                                    setShowOpportunitiesList(false);
                                }
                            }}
                        >
                            {opportunity.sfdcOpportunityName}
                        </div>
                    ))}
                </SidebarPortal>
            )}
            {!showCompanyList && !showOpportunitiesList && (
                <SidebarPortal>
                    <>
                        <div className="mb-6 flex items-center gap-2">
                            <ChevronLeftIcon className="size-4 text-gray-400" />
                            <span
                                className="ui-element subdued cursor-pointer"
                                onClick={() => setShowOpportunitiesList(true)}
                            >
                                Opportunities
                            </span>
                        </div>
                        <MemoNavigator />
                    </>
                </SidebarPortal>
            )}
            {router.params.opportunityId && (
                <InvestmentMemo opportunityId={router.params.opportunityId} />
            )}
        </div>
    );
}
